// Types
import { ToolNameValue } from 'app/store/pagesToolbar/pagesToolbar.types';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectNewDesignEnabled } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Mui
import { Container } from '@mui/material';
// Utils
import { usePagesToolbarContext } from './utils/usePagesToolbarContext';

const FiltersContainer = () => {
  const { tools, hiddenTools } = usePagesToolbarContext();

  // State
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);

  if ( newDesignEnabled ) return null;
  return (
    <Container
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 4,
        py: 4,
        // ToDO: Hz is this the best way to do this, set maxWidth for all autocompletes
        '& .MuiAutocomplete-root': {
          maxWidth: 280
        }
      }}
      maxWidth={false}
    >
      {Object.keys(tools.additionalBar).map((key) => {
        const Tool = tools.additionalBar[key as ToolNameValue];
        const isHidden = hiddenTools.includes(key as ToolNameValue);
        if ( isHidden ) return null;
        return <Tool key={key} />
      })}
    </Container>
  )
}

export default FiltersContainer;
